import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { concatAndDeDuplicateObjects } from '@/lib/utils';

interface SmallWorkItem {
  id: string;
  [key: string]: any;
}

interface SmallWorksState {
  items: SmallWorkItem[];
  loading: boolean;
  error: string | null;
}

const initialState: SmallWorksState = {
  items: [],
  loading: false,
  error: null,
};

const smallworksSlice = createSlice({
  name: 'smallworks',
  initialState,
  reducers: {
    // Action creators for Redux Offline
    addSmallWorks: (state, action: PayloadAction<SmallWorkItem>) => {
      state.items = [action.payload, ...state.items];
    },
    addSmallWorksCommit: (state) => {
      // Handle success if needed
    },
    addSmallWorksFailed: (state, action: PayloadAction<string>) => {
      state.error = action.payload;
    },

    updateSmallWorks: (state, action: PayloadAction<SmallWorkItem>) => {
      const index = state.items.findIndex(item => item.id === action.payload.id);
      if (index !== -1) {
        state.items[index] = action.payload;
      }
    },
    updateSmallWorksCommit: (state) => {
      // Handle success if needed
    },
    updateSmallWorksFailed: (state, action: PayloadAction<string>) => {
      state.error = action.payload;
    },
  },
  extraReducers: (builder) => {
    // Handle data from GET_BOOKINGS_COMMIT
    builder.addCase('GET_BOOKINGS_COMMIT', (state, action: PayloadAction<{
      smallworks?: SmallWorkItem[];
      bookings?: any[];
      [key: string]: any;
    }>) => {
      const { smallworks } = action.payload;
      const { meta } = action as any;

      const isPagedRequest = meta && meta.page !== undefined && meta.page > 0;

      if (isPagedRequest) {
        if (smallworks && smallworks.length > 0) {
          state.items = concatAndDeDuplicateObjects('id', state.items, smallworks);
        }
      } else {
        // First page load or refresh - replace all smallworks
        state.items = smallworks || [];
      }
    });
  },
});

export const {
  addSmallWorks,
  addSmallWorksCommit,
  addSmallWorksFailed,
  updateSmallWorks,
  updateSmallWorksCommit,
  updateSmallWorksFailed,
} = smallworksSlice.actions;

export default smallworksSlice.reducer;